<template>
  <b-field :type="type">
    <b-select @input="selectValue" v-model="selected" :icon="icon" expanded :loading="loading">
      <template v-if="this.groupBy">
        <optgroup v-for="groupLabel in groupLabels"
          :key="groupLabel"
          :label="$gettext(`${entity}.${groupBy}.${groupLabel}`)"
        >
          <option
            v-for="option in groups[groupLabel]"
            :value="option._id"
            :key="option._id"
          >
            {{ option._stringRep }}
          </option>
        </optgroup>
      </template>
      <template v-else>
        <option
          v-for="option in values"
          :value="option._id"
          :key="option._id">
          {{ option._stringRep }}
        </option>
      </template>
    </b-select>
  </b-field>
</template>

<script>
import api from '@/api'

export default {
  name: 'fob-entity-select-prefetched',
  data () {
    return {
      values: [],
      selected: null,
      loading: true,
      groupLabels: null,
      groups: {}
    }
  },
  props: [
    'entity', 'searchMethod', 'icon', 'value', 'groupBy',
    'type', 'preselect', 'prefilter', 'orderBy', 'reorder'
  ],
  mounted () {
    api.methods.find(this.entity, this.searchMethod, this.orderBy)
    .then(async ({ data, meta }) => {
      if (this.prefilter instanceof Function) {
        this.values = data.filter(this.prefilter)
      } else {
        this.values = data
      }

      if (this.reorder) {
        data = this.reorder.map(i => data.find(x => x._id === i))
      }

      if (this.groupBy != null) {
        this.groupLabels =
          data
          .map(x => x[this.groupBy])
          .reduce((x, y) => x.includes(y) ? x : [...x, y], [])
          .sort()
        for (let item of data) {
          let g = item[this.groupBy]
          if (this.groups[g] == null) {
            this.groups[g] = []
          }
          this.groups[item[this.groupBy]].push(item)
        }
      }

      if (this.value != null) {
        this.selected = this.values.find(x => x._id === this.value._id)._id
      } else if (this.preselect instanceof Function) {
        this.selected = this.values.find(this.preselect)._id
      }
      this.loading = false
    })
  },
  methods: {
    selectValue () {
      let selectedEntity = this.values.find(x => x._id === this.selected)
      this.$emit('input', selectedEntity)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/form/EntitySelectPrefetched.vue